import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=7875ebfa&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875ebfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7875ebfa')) {
      api.createRecord('7875ebfa', component.options)
    } else {
      api.reload('7875ebfa', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=7875ebfa&scoped=true&", function () {
      api.rerender('7875ebfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports